export const featureFlagKeys = ['stages', 'dev_view'] as const;

export type FeatureFlag = (typeof featureFlagKeys)[number];

export type FeatureFlagMap = Partial<Record<FeatureFlag, boolean>>;

export const cookieName = 'ff';
